var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-navigation-bar',{staticClass:"sticky-top",staticStyle:{"background-color":"#d5d5d5f7","height":"62px"},attrs:{"options":_vm.navbarOptions},on:{"vnb-item-clicked":_vm.vnbItemClicked}})}
var staticRenderFns = []

export { render, staticRenderFns }